import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7726ff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content-container"
}
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "table-button",
  disabled: ""
}, " Export Report ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]

import { ref, onMounted } from "vue";
import TablePersistentChecking, {
    ITableExpose,
} from "@/components/TablePersistentChecking.vue";
import { downloadManager, vcfsPaymentsService } from "@/services/network";
import useNotifier from "@/services/composables/Notifier";
import { IVcfsPaymentItem } from "@/Interfaces/Payments/IVcfsPaymentItem";
import VcfsCreatePaymentsPopUp from "@/components/VcfsCreatePaymentsPopUp.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import VcfsConfirmPaymentsPopUp from "@/components/VcfsConfirmPaymentsPopUp.vue";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";
import { authService } from "@/auth/authSingleton";
import { FileDownloadType } from "@/models/enums/FileDownloadTypes";

interface DownloadStatusHelperInterface {
    paymentReference: string;
    downloadPressed: boolean;
}
const sortCol: keyof IVcfsPaymentItem = 'paymentReference';

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsToVCFS',
  setup(__props) {

const cols: (keyof IVcfsPaymentItem)[] = [
    "paymentReference",
    "paymentFrom",
    "paymentTo",
    "paymentDate",
    "cutoffDate",
    "amount",
    "amount"
];
const labels = [
    "Payment Reference",
    "Payment From",
    "Payment To",
    "Payment Date",
    "Cutoff Date",
    "Amount",
    "Report"
];
const defaultSortCols = ref([cols.findIndex((col) => {return col === sortCol;}),]);
const defaultSortOrders = ref<(1|-1)[]>([-1]);
const table = ref<ITableExpose<IVcfsPaymentItem[]>>();
const checkedRow = ref<IVcfsPaymentItem>();
const createPaymentPopup = ref(false);
const vcfsPaymentsList = ref<IVcfsPaymentItem[]>([]);
const downloadStateHelperList = ref<DownloadStatusHelperInterface[]>([]);
const emailAddress = ref();

const isLoading = ref(false);  

onMounted(async () => {
    getVcfsPayments();
    emailAddress.value = authService.getEmailAddress();
});
async function getVcfsPayments() {
    try {
        isLoading.value = true;
        vcfsPaymentsList.value = (await vcfsPaymentsService.get()).data;
        updateSelection();
        createDownloadStatusHelperElement()
    } catch (error) {
        useNotifierWithErrFormatter().error({errorType: "Getting VCFS payments", error: error});
    } finally {
        isLoading.value = false;
    }
}
function proceedToVcfsCreationPopUp(){
    createPaymentPopup.value = true
}
function proceedToVcfsConfirmationPopUp() {
    const selectedRow = table.value?.GetChecked()?.[0]  as IVcfsPaymentItem | undefined;
    if (selectedRow == undefined)  {
        useNotifier().notify({msg:'No item has been checkmarked. Please select the payment that you wish to confirm.'});
        return;
    }
    checkedRow.value = selectedRow
}
const updateSelection = () => {
    checkedRow.value = undefined;
};
function refreshAfterConfirm() {
    getVcfsPayments();
    updateSelection();
    createPaymentPopup.value = false;
    ClearTableSelection()
}
function ClearTableSelection(){
    table.value?.ClearChecked()
}
function createDownloadStatusHelperElement() {
    downloadStateHelperList.value = vcfsPaymentsList.value.map((x) => ({
        paymentReference: x.paymentReference,
        downloadPressed: false,
    }));
}
function isDownloadDisabled(paymentReference: string) {
    const helperReference = downloadStateHelperList.value.find(
        (x) => x.paymentReference === paymentReference
    );
    return helperReference?.downloadPressed;
}
async function downloadFile(paymentReference: string) {  
    try {
        await downloadManager.post({
            userName: emailAddress.value,
            type: FileDownloadType.VCFS_PAYMENT_REPORT,
            requestData:
            {
                PaymentReference: paymentReference
            }
        })
        useNotifierWithErrFormatter().success({
            msg: "Vcfs payment report was queued for download"
        });
        const i = downloadStateHelperList.value.findIndex(x => x.paymentReference === paymentReference);    
        downloadStateHelperList.value[i] = {
            ...downloadStateHelperList.value[i],
            downloadPressed: true,
        };
    } catch(error) {
        useNotifierWithErrFormatter().error({
            errorType: "Vcfs payment report download queue error",
            error,
        });
    }

}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", { class: "top-content" }, [
          _createElementVNode("div", { class: "flex-row-centered center-buttons" }, [
            _createElementVNode("button", {
              onClick: proceedToVcfsCreationPopUp,
              class: "button-styling"
            }, " Create Payment"),
            _createElementVNode("button", {
              onClick: proceedToVcfsConfirmationPopUp,
              class: "button-styling"
            }, "Confirm Payment")
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TablePersistentChecking, {
            ref_key: "table",
            ref: table,
            Rows: vcfsPaymentsList.value,
            Cols: cols,
            Labels: labels,
            HasCheckBox: true,
            SingleSelection: true,
            RowCheckableFilter: x=>x.paymentDate=='' || x.paymentDate==null ,
            DefaultSortCols: defaultSortCols.value,
            DefaultSortOrders: defaultSortOrders.value
          }, {
            amount: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(props.value.amount)), 1)
            ]),
            "amount-1": _withCtx((props) => [
              (isDownloadDisabled(props.value.paymentReference) == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (downloadFile(props.value.paymentReference)),
                      class: "table-button"
                    }, " Export Report ", 8, _hoisted_10)
                  ]))
            ]),
            _: 1
          }, 8, ["Rows", "RowCheckableFilter", "DefaultSortCols", "DefaultSortOrders"])
        ]),
        _createVNode(VcfsConfirmPaymentsPopUp, {
          modelValue: checkedRow.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkedRow).value = $event)),
          onConfirm: refreshAfterConfirm,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (ClearTableSelection()))
        }, null, 8, ["modelValue"]),
        _createVNode(VcfsCreatePaymentsPopUp, {
          modelValue: createPaymentPopup.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createPaymentPopup).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"])
      ]))
}
}

})